/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Aria_BackInputs */

const vi_common_aria_back = /** @type {(inputs: Common_Aria_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại`)
};

/**

* @param {Common_Aria_BackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_aria_back = /** @type {((inputs?: Common_Aria_BackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Aria_BackInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_aria_back(inputs)
});